import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { HttpInterceptorInterceptor } from './servicios/http-interceptor.interceptor';
import { ErrorComponent } from './componentes/error/error.component';

@NgModule({ declarations: [
        AppComponent,
        ErrorComponent
    ],
    bootstrap: [AppComponent], imports: [AppRoutingModule,
        CommonModule,
        BrowserModule,
        SharedModule,
        BrowserAnimationsModule,
        MatNativeDateModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorInterceptor, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }


